import React, { useEffect, useRef } from 'react';
import CheckboxCheck from 'assets/CheckboxCheck.svg';

/*
 * ListSelectionCheckbox.tsx
 * Compact checkbox used for the bulk-actions selection column, both in the
 * list header (with indeterminate support) and in every row. Unlike the
 * form-oriented Checkbox.tsx, this variant has no mandatory label.
 */

interface ListSelectionCheckboxProps {
    id: string;
    checked: boolean;
    indeterminate?: boolean;
    onChange: () => void;
    ariaLabel?: string;
}

const ListSelectionCheckbox: React.FC<ListSelectionCheckboxProps> = ({
    id, checked, indeterminate = false, onChange, ariaLabel
}) => {
    // Reference the input to set its native indeterminate state
    const inputRef = useRef<HTMLInputElement>(null);

    // Sync the indeterminate visual state, not settable as a plain html attribute
    useEffect(() => {
        if (inputRef.current) {
            inputRef.current.indeterminate = indeterminate;
        }
    }, [indeterminate]);

    return (
        <div className='checkbox-wrapper list-selection-checkbox'>
            <input
                ref={inputRef}
                type='checkbox'
                id={id}
                checked={checked}
                onChange={onChange}
                className='hidden-checkbox'
                aria-label={ariaLabel}
            />
            <label htmlFor={id}
                   className={`custom-checkbox ${checked ? 'checked' : ''} ${indeterminate ? 'indeterminate' : ''}`}>
                {checked && !indeterminate && (
                    <img src={CheckboxCheck} alt='' className='checkbox-check' />
                )}
                {indeterminate && (
                    <span className='checkbox-indeterminate-mark' />
                )}
            </label>
        </div>
    );
};

export default ListSelectionCheckbox;
